import { fromJS } from "immutable";

import { CHANGE_LOCALE } from "../actions/languageProvider";

import objectAssign from "object-assign";

import { languageProviderInitialState } from "../state/initialState";

function languageProviderReducer(state = languageProviderInitialState, action) {
  let newStatus;
  switch (action.type) {
    case CHANGE_LOCALE:
      newStatus = {
        locale: action.locale
      };
      return objectAssign({}, state, newStatus);
    default:
      return state;
  }
}

export default languageProviderReducer;
